// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_2i4IY","text":"index_text_26ScR","textHidden":"index_textHidden_3PTxG","contentBox":"index_contentBox_Az4Mj","boxTitle":"index_boxTitle_1sv20"};